import axios, { CreateAxiosDefaults } from 'axios';

export const config: CreateAxiosDefaults = {
  baseURL: 'https://gate.jgarant.kz', // для теста убрать `${process.env.REACT_APP_CORE_API_URL}`,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  timeout: 60000,
};

const API_GATE = axios.create(config);

export default API_GATE;
